module.exports = __webpack_public_path__ + "img/EXTERIOR-SCROSS-3.1fc3246d.jpg";